import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=66bd86f9&scoped=true&"
var script = {}
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=66bd86f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd86f9",
  null
  
)

export default component.exports